import React, { Component } from 'react'
import {
  Route
} from 'react-router-dom';
import Cookies from 'universal-cookie';
import _l from 'lodash';

import * as history from '../common/history.js';
import Login from './login/Login.js';
import Panel from './panel/Panel.js';

const cookies = new Cookies();

class AdminPanel extends Component {
  constructor() {
    super();
  }

  componentWillMount() {
    const isLoggedIn = cookies.get('isLoggedIn') === 'true';
    // const isLoggedIn = true; // TODO: Rollback to above line

    this.setState({
      isLoggedIn,
    }, () => {
      const targetLocation = isLoggedIn ? '/adminPanel/panel' : '/adminPanel/login';
      if (!_l.startsWith(history.getCurrentLocation(), targetLocation)) history.replace(targetLocation);
    });
  }

  render() {
    return (
      <div className="admin-panel-block">
        <Route path="/adminPanel/login" component={Login} />
        <Route path="/adminPanel/panel" component={Panel} />
      </div>
    )
  }
}

export default AdminPanel;


// WEBPACK FOOTER //
// client/adminPanel/AdminPanel.js